import { SubmissionError, reset } from 'redux-form';
import { call, put, takeLatest } from 'redux-saga/effects'

import Api from '../Api'
import mixpanel from 'mixpanel-browser';
import { push } from 'connected-react-router'
import { actions as signupActions } from './signup/signup'

export const types = {
    LOGIN: 'LOGIN/LOGIN',
    LOAD_DETAILS: 'LOGIN/LOAD_DETAILS',
    LOGIN_BCC: 'LOGIN/LOGIN_BCC',
    BCC_RESULT: 'LOGIN/BCC_RESULT',
    FETCH_SSO_LINK: 'LOGIN/FETCH_SSO_LINK',
    FETCH_SSO_LINK_SUCCESS: 'LOGIN/FETCH_SSO_LINK_SUCCESS',
}

export const actions = {
    login: (params, reject, resolve) => ({ type: types.LOGIN, params, reject, resolve }),
    loadDetails: (params) => ({ type: types.LOAD_DETAILS, params }),
    loginBcc: () => ({ type: types.LOGIN_BCC }),
    BccResults: (errors) => ({ type: types.BCC_RESULT, errors }),
    fetchSSOLink: () => ({ type: types.FETCH_SSO_LINK }),
    fetchSSOLinkSuccess: (ssolink) => ({ type: types.FETCH_SSO_LINK_SUCCESS, ssolink }),
}

export const initialState = {
    loading: false,
    errors: '',
    loginURL:'',
    initialValues: {}
}

export default (state = initialState, action) => {
    switch (action.type) {
        case types.LOAD_DETAILS:
            return {
                ...state,
                initialValues: {
                    ...state.initialValues,
                    ...action.params,
                }
            }
        case types.LOGIN_BCC:
            return {
                ...state,
                loading: true,
            }
        case types.BCC_RESULT:
            return {
                ...state,
                loading: false,
                errors: action.errors,
            }
        case types.FETCH_SSO_LINK_SUCCESS:
            return{
                ...state,
                loginURL: action.ssolink.data,
            }
        default:
            return state
    }
}

/* Sagas */
export function* fetchSSOLink(action) {
    try {
        const data = yield call(Api.fetchSSOLink);
        yield put(actions.fetchSSOLinkSuccess(data))
    } catch (e) {
        console.log(e);
    }
}

export function* login(action) {
    try {
        const data = yield call(Api.login, action.params);
        mixpanel.track('LoggedIn', { AccountStatus: 'Existing' });
        yield put(push('/'))
        yield put(actions.loadDetails(data));
        yield call(action.resolve)
    } catch (e) {
        if (e.response.status === 428) {
            yield put(signupActions.loadData({
                email: action.params.email,
                password: action.params.password,
                password2: action.params.password,
                pid: action.params.pid,
                vid: action.params.vid,
                new_user: 0
            }, false));
            yield put(push('/signup/existing-user'));
            yield put(reset('LoginForm'));
        }
        if (e.response !== undefined) {
            const errors = e.response.data.errors;
            errors.email = errors[0]
            yield call(action.reject, new SubmissionError(errors))
        } else {
            yield call(action.reject)
        }
    }
}

export function* loginBcc() {
    try {
        yield call(Api.checkBcc);
        yield put(push('/'));
        yield put(actions.BccResults('')); // disable loading
    }
    catch (e) {                
        if (e.response.status === 424) {
            yield put(actions.BccResults(e.response.data.errors.email));
        } else if (e.response.status === 428) {
            yield put(signupActions.loadData({
                email: e.response.data.email,
                password: 'password',
                password2: 'password',
                new_user: 0
            }, false));
            yield put(push('/signup/existing-user'));
            yield put(reset('LoginForm'));  
            yield put(actions.BccResults('')); // disable loading
        } else {
            yield put(actions.BccResults(e.response.data.errors));
        }
    }
}

export function* loginPageFlow() {
    yield takeLatest(types.LOGIN, login);
    yield takeLatest(types.LOGIN_BCC, loginBcc);
    yield takeLatest(types.FETCH_SSO_LINK, fetchSSOLink);
}